import { render, staticRenderFns } from "./UserTranslation.vue?vue&type=template&id=d8ddf35e&scoped=true"
import script from "./UserTranslation.vue?vue&type=script&lang=js"
export * from "./UserTranslation.vue?vue&type=script&lang=js"
import style0 from "./UserTranslation.vue?vue&type=style&index=0&id=d8ddf35e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ddf35e",
  null
  
)

export default component.exports